import { useTranslation } from 'next-i18next'
import styles from './index.module.sass'

const Illustrate = () => {
  const { t } = useTranslation()

  return (
    <p className={styles.text}>{t('client.shoplist.desc.disclaimer')}</p>
  )
}

export default Illustrate
